import { HttpCost, getHttpCost } from 'trtc-js-sdk-core/src/utils/get-http-cost';

/**
 * 利用 cors 跨域的预检请求，来模拟 ping，就算请求失败了，跨域预检请求也会走一次完整的 http 请求。
 */
export function ping(ip: string): Promise<HttpCost> {
  return new Promise(async resolve => {
    const timeoutId = setTimeout(() => {
      const result: HttpCost = { totalCost: 10000, local: 0, dns: 0, tcp: 0, tls: 0, request: 0, response: 0 };
      resolve(result);
    }, 10000);

    const start = Date.now();
    const url = `https://${ip}/?t=${start}`;

    try {
      await fetch(url);
    } catch (error) {}
    clearTimeout(timeoutId);
    const result = getHttpCost(url);
    if (result.totalCost === 0) result.totalCost = Date.now() - start;
    resolve(result);
  });
}
